import apiDB from './api_db';

let alarm = new apiDB({
    api_module: 'race_history_competitors',
    table_key_name: 'id',
    reducer_name: 'raceR',
    reducer_var: 'history_events_competitors',
    action_prefix: 'RACE_HISTORY_EVENT',
    linked_table: 'history_events',
    linked_table_key_name: 'race_id'});

export default alarm;

